// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"yM-z","upvoteIcon":"zM-z","downvoteIcon":"AM-z","feedbackIcon":"BM-z"};